import React from 'react'
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder'
import BookmarkIcon from '@mui/icons-material/Bookmark'
import {
  SmallCard,
  MediumCard,
  MediumCardContent,
  LargeCard,
  LargeCardContent,
  CardImage,
  LargeCardImage,
  LargeCardTitle,
  LargeCardDetails,
  CardDetails,
  SmallCardDetails,
  ChipWrapper,
  CardTitle,
  BookmarkWrapper,
  CardSummary,
} from './ContentCard.styled'
import { Button } from '../Button/Button'

type Props = {
  imageSrc: string
  title: string
  summary: string
  size?: 'small' | 'medium' | 'large'
  chips: React.ReactNode[]
  isBookmarked: boolean
  onBookmarkClick: (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => void
  onCardClick: () => void
}

export const ContentCard = ({
  imageSrc,
  title,
  summary,
  size = 'medium',
  chips,
  isBookmarked,
  onBookmarkClick,
  onCardClick,
}: Props) => {
  let cardToRender

  const mediumSizeCard = (
    <MediumCard>
      <MediumCardContent tabIndex={0} onClick={onCardClick}>
        <CardImage src={imageSrc} />
        <CardDetails>
          <div>
            <CardTitle>{title}</CardTitle>
            <CardSummary>{summary}</CardSummary>
          </div>
          <ChipWrapper>{chips}</ChipWrapper>
        </CardDetails>
      </MediumCardContent>
      <BookmarkWrapper tabIndex={0}>
        <Button
          variant='chip'
          flush='top'
          label=''
          leadingIcon={isBookmarked ? <BookmarkIcon /> : <BookmarkBorderIcon />}
          onClick={onBookmarkClick}
        />
      </BookmarkWrapper>
    </MediumCard>
  )

  const smallSizeCard = (
    <SmallCard onClick={onCardClick}>
      <SmallCardDetails>
        <CardTitle>{title}</CardTitle>
        <ChipWrapper>{chips.slice(0, 2)}</ChipWrapper>
      </SmallCardDetails>
    </SmallCard>
  )

  const largeSizeCard = (
    <LargeCard>
      <LargeCardContent tabIndex={0} onClick={onCardClick}>
        <LargeCardImage src={imageSrc} />
        <LargeCardDetails>
          <LargeCardTitle>{title}</LargeCardTitle>
          <ChipWrapper>{chips}</ChipWrapper>
        </LargeCardDetails>
      </LargeCardContent>
      <BookmarkWrapper tabIndex={0}>
        <Button
          variant='chip'
          flush='top'
          label=''
          leadingIcon={isBookmarked ? <BookmarkIcon /> : <BookmarkBorderIcon />}
          onClick={onBookmarkClick}
        />
      </BookmarkWrapper>
    </LargeCard>
  )

  switch (size) {
    case 'small':
      cardToRender = smallSizeCard
      break
    case 'medium':
      cardToRender = mediumSizeCard
      break
    case 'large':
      cardToRender = largeSizeCard
      break
    default:
      cardToRender = mediumSizeCard
  }

  return cardToRender
}
